import React, {Component} from 'react';
import {BreadCumb, DataTables, NavBar} from "../../components";
import config from "../../config";
import moment from "moment";
import {ApiClient} from "../../libs/apiClient";
import {DISPATCH_ID, SERVICE_RESPONSE} from "../../libs/utils/Const";
import {connect} from "react-redux";

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    {title: "Serie", value: true},
    {title: "Num.Doc", value: true},
    {title: "Cliente", value: true},
    {title: "Nombre", value: true},
    {title: "Fecha Cont.", value: true},
    {title: "Empl. Ventas", value: true},
    {title: "Titular Doc.", value: true},
    {title: "Comentarios", value: true},
    {title: "Total", value: true},
    {title: "Estatus", value: true},
    {title: "Fecha Entrega/ Vencimiento", value: true},
    {title: "Docs Vencidos", value: true},
    {title: "Facturado", value: true},
    {title: "Pagado", value: true},
    {title: "Vencido", value: true}]

class ExitHelmetsView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }

    }

    async componentDidMount(): void {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liExitHelmets");
        let today =  moment(new Date()).format('YYYYMMDD');

        let date= {
            dateInit:today,
            dateFinal:today,
        }
        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async newDate => {

        const {notificationReducer:  { showAlert }, enableSpinner } = this.props;
        let data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            groupCodeValue : newDate.groupCodeValue || '---',
            employeeValue :newDate.employeeValue || '---',
            table: "OIGEE",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--'
        };
    
        enableSpinner(true);
        let transfersListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if(transfersListResponse.status === SERVICE_RESPONSE.SUCCESS){
            let dataSerie = {
                docType: "60",
                docSubType: "--"
            };
            let dataSerie2 = {
                docType: "13",
                docSubType: "DN"
            };

            enableSpinner(true);
            let seriesResponse = await apiClient.getSeries(dataSerie);
            let seriesResponse2= await apiClient.getSeries(dataSerie2);
            enableSpinner(false);
            
            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            let ValidateSeries = user.U_FMB_ValidateSeriesOIGE ? user.U_FMB_ValidateSeriesOIGE : "";

            if (!user || ValidateSeries == "") {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
                });

                this.setState({
                    data: [],
                });
                return;
            }

            let seriesUsers = ValidateSeries.split("|");


            let newArraySeries = [];
            
            seriesUsers.map(serieUser => {
                seriesResponse.data.map(serieResponse => {
                    if (serieResponse.Series == serieUser) {
                        newArraySeries.push(serieResponse);
                    }
                })
            })

            if (newArraySeries.length === 0) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "El usuario no tiene serie permitida de escritura y lectura"
                });
                return;
            }

            let newDocumentsfilterSeries = [];

            transfersListResponse.data.map(document => {
                newArraySeries.map(serie => {
                    if(document.SeriesCode == serie.Series){
                        newDocumentsfilterSeries.push(document);
                    }
                })
            });

            this.setState({
                data: newDocumentsfilterSeries,
            });
            return;
        }

        //showAlert({type: 'error', message: transfersListResponse.message});
    }


    searchDocuments = async date => {
        //console.log(date);
        await this.callDocumentsListService(date);
    };

    render() {
        const {headers, data, updateData,_user} = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user}/>
                <BreadCumb subitem1={'SALIDA DE MERCANCÍA CASCOS'} url1={'#'}/>
                <div style={{marginLeft: "4rem", marginBottom: "12rem"}}>

                    <h2 className="md-display-1">
                        <a id="linkOrdProv" className="text-muted">SALIDA DE MERCANCÍA CASCOS
                        </a>
                    </h2>
                    <DataTables headers={headers} view={"ExitHelmets"} data={data} search={this.searchDocuments} />
                    
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value})
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExitHelmetsView);